{
  "main": "./index",
  "version": "1.0.2",
  "scripts": {
    "start": "npx expo start",
    "android": "npx expo start --android",
    "ios": "npx expo start --ios",
    "web": "npx expo start --web",
    "build": "node scripts/expo-export.cjs -p web --source-maps",
    "build:production": "node scripts/expo-export.cjs -p web --source-maps && node scripts/sentry-upload.cjs",
    "predeploy": "yarn sync-media && yarn sitemap && yarn prebuild-github-cards && yarn articles:build && yarn build:production",
    "prebuild-github-cards": "bun scripts/prebuild-github-cards.ts",
    "export": "npx expo export --source-maps",
    "export:sentry": "npx expo export --source-maps && node scripts/sentry-upload.cjs",
    "build:dev": "NODE_ENV=development npx expo export -p web && NODE_ENV=development npx expo serve",
    "preview": "npx expo start --web --offline",
    "sitemap": "node sitemap-gen.js",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:headed": "playwright test --headed",
    "e2e:debug": "playwright test --debug",
    "e2e:install": "playwright install",
    "e2e:http": "playwright test --config=playwright-http.config.ts",
    "clean": "rm -rf .expo .next dist",
    "prepare": "npx patch-package",
    "start:dev": "NODE_ENV=development && bun start --web",
    "start:prod": "NODE_ENV=production && bun start --web",
    "drizzle:generate:dev": "NODE_ENV=development drizzle-kit generate",
    "drizzle:migrate:dev": "NODE_ENV=development drizzle-kit migrate",
    "drizzle:generate:prod": "NODE_ENV=production drizzle-kit generate",
    "drizzle:migrate:prod": "NODE_ENV=production drizzle-kit migrate",
    "format": "prettier --write \"**/*.{js,jsx,ts,tsx,json,md,mdx}\"",
    "format:check": "prettier --check \"**/*.{js,jsx,ts,tsx,json,md,mdx}\"",
    "generate:thumbnails": "node utils/generate-thumbnails.js",
    "sync-media": "node scripts/sync-media.ts",
    "lint": "eslint . --ext .js,.jsx,.ts,.tsx",
    "command:refund": "npx ts-node scripts/refund-subscription.ts",
    "apple:secret:dev": "NODE_ENV=development ts-node scripts/apple/gen-secret.ts",
    "apple:secret:prod": "NODE_ENV=production ts-node scripts/apple/gen-secret.ts",
    "create-demo": "tsx scripts/create-demo/index.ts",
    "test": "jest --maxWorkers=1",
    "test:watch": "jest --watch",
    "test:coverage": "jest --coverage",
    "test:unit": "jest --testPathPattern=__tests__",
    "test:e2e": "bun e2e",
    "typecheck": "npx tsc --noEmit"
  },
  "dependencies": {
    "@amplitude/analytics-browser": "^2.17.8",
    "@babel/plugin-transform-export-namespace-from": "^7.25.9",
    "@bacons/mdx": "^0.3.7",
    "@expo-google-fonts/inter": "^0.2.3",
    "@expo-google-fonts/poppins": "^0.2.3",
    "@expo-google-fonts/source-code-pro": "^0.2.3",
    "@expo/html-elements": "^0.10.1",
    "@expo/schema-utils": "^0.1.7",
    "@expo/server": "0.5.1",
    "@expo/vector-icons": "^15.0.2",
    "@headlessui/react": "^2.2.0",
    "@lemonsqueezy/lemonsqueezy.js": "^3.3.1",
    "@number-flow/react": "^0.6.0",
    "@radix-ui/react-checkbox": "^1.1.2",
    "@radix-ui/react-dialog": "^1.1.2",
    "@react-native-async-storage/async-storage": "2.2.0",
    "@sentry/react-native": "~7.11.0",
    "@shopify/react-native-skia": "2.4.18",
    "@tanstack/query-core": "^5.60.6",
    "@tanstack/query-sync-storage-persister": "^5.61.5",
    "@tanstack/react-query": "^5.59.16",
    "@tanstack/react-query-persist-client": "^5.61.5",
    "axios": "^1.10.0",
    "class-variance-authority": "^0.7.0",
    "clsx": "^2.1.1",
    "color": "^4.2.3",
    "date-fns": "^4.1.0",
    "drizzle-orm": "^0.35.2",
    "expo": "~55.0.1",
    "expo-blur": "~55.0.8",
    "expo-constants": "~55.0.7",
    "expo-font": "~55.0.4",
    "expo-image": "~55.0.5",
    "expo-linear-gradient": "~55.0.8",
    "expo-linking": "~55.0.7",
    "expo-router": "~55.0.3",
    "expo-splash-screen": "~55.0.10",
    "expo-status-bar": "~55.0.4",
    "framer-motion": "^11.11.9",
    "jotai": "^2.10.1",
    "jotai-tanstack-query": "^0.9.0",
    "jsonwebtoken": "^9.0.2",
    "lucide-react": "^0.453.0",
    "moti": "^0.30.0",
    "nativewind": "^4.1.23",
    "patreon": "^0.4.1",
    "pino": "^9.5.0",
    "postgres": "^3.4.4",
    "prism-react-renderer": "^2.0.6",
    "prismjs": "^1.29.0",
    "qr-code-styling": "^1.9.2",
    "react": "19.2.0",
    "react-dom": "19.2.0",
    "react-intersection-observer": "^9.13.1",
    "react-native": "0.83.2",
    "react-native-gesture-handler": "~2.30.0",
    "react-native-reanimated": "4.2.1",
    "react-native-redash": "^18.1.3",
    "react-native-safe-area-context": "~5.6.0",
    "react-native-screens": "~4.23.0",
    "react-native-skia-gesture": "^0.3.6",
    "react-native-svg": "15.15.3",
    "react-native-web": "^0.21.0",
    "react-native-webview": "13.16.0",
    "react-native-worklets": "0.7.2",
    "react-qr-code": "^2.0.18",
    "react-youtube": "^10.1.0",
    "sonner": "^1.5.0",
    "tailwind-merge": "^2.5.4",
    "vaul": "^1.1.1",
    "zod": "^3.23.8"
  },
  "resolutions": {
    "@expo/config-plugins": "~9.0.0",
    "@expo/prebuild-config": "^8.0.0"
  },
  "optionalDependencies": {
    "@libsql/client-wasm": "^0.15.8"
  },
  "devDependencies": {
    "@babel/core": "^7.25.2",
    "@babel/plugin-transform-dotall-regex": "^7.24.7",
    "@babel/plugin-transform-private-methods": "^7.25.9",
    "@babel/plugin-transform-react-display-name": "^7.27.1",
    "@eslint/js": "^9.29.0",
    "@expo/cli": "^0.21.5",
    "@jest/globals": "^30.0.0",
    "@playwright/test": "^1.49.1",
    "@sentry/cli": "^2.46.0",
    "@svgr/core": "^8.1.0",
    "@svgr/plugin-jsx": "^8.1.0",
    "@svgr/plugin-svgo": "^8.1.0",
    "@types/chrome": "^0.0.278",
    "@types/color": "^4.2.0",
    "@types/fbjs": "^3",
    "@types/jest": "^29.5.14",
    "@types/jsonwebtoken": "^9.0.7",
    "@types/lodash.debounce": "^4.0.9",
    "@types/node": "^22.10.2",
    "@types/prop-types": "^15",
    "@types/react": "~19.1.10",
    "@types/react-dom": "~19.1.7",
    "@typescript-eslint/eslint-plugin": "^8.15.0",
    "@typescript-eslint/parser": "^8.15.0",
    "autoprefixer": "10.4.14",
    "babel-plugin-module-resolver": "^5.0.2",
    "babel-plugin-react-compiler": "19.0.0-beta-af1b7da-20250417",
    "babel-plugin-transform-imports": "^2.0.0",
    "csv-parse": "^5.6.0",
    "dotenv": "^16.4.5",
    "drizzle-kit": "^0.27.2",
    "enquirer": "^2.4.1",
    "eslint": "^9.17.0",
    "eslint-config-react-native-wcandillon": "^3.10.2",
    "eslint-config-universe": "^14.0.0",
    "eslint-plugin-jest": "^28.9.0",
    "eslint-plugin-prettier": "^5.4.1",
    "eslint-plugin-react-compiler": "^19.1.0-rc.2",
    "eslint-plugin-react-hooks": "^5.2.0",
    "express": "^4.18.2",
    "jest": "~29.7.0",
    "jest-environment-node": "^30.0.0",
    "lighthouse": "^12.2.1",
    "morgan": "^1.10.0",
    "postcss": "^8.5.4",
    "postcss-scss": "^4.0.6",
    "prettier": "^3.3.3",
    "sass": "^1.63.4",
    "satori": "0.10.4",
    "tailwindcss": "3.4.17",
    "tailwindcss-animate": "^1.0.7",
    "tailwindcss-safe-area": "^0.4.0",
    "ts-jest": "^29.4.0",
    "tsx": "^4.19.2",
    "typescript": "~5.9.2"
  },
  "private": true,
  "packageManager": "yarn@4.9.2"
}
